<template>
  <div class="case-outer">
    <div class="topbanner ut-container-lg ut-relative">
      <div
        v-if="user.key"
        class="
          ut-pt-6
          ut-px-6
          ut-pb-6
          ut-mb-6
          ut-inline-block
          ut-w-full
          ut-flex
          ut-cursor-pointer
          logo
        "
      >
        <div class="ut-float-left ut-content-center ut-ml-0">
          <img
            v-if="isPremier"
            src="@/assets/styles/frontend-library/images/logo-openagent-green-white-premier.svg"
            alt="OpenAgent"
            width="210"
            class="lg:ut-block"
          />
          <img
            v-else
            src="@/assets/styles/frontend-library/images/logo-openagent-green-white.svg"
            alt="OpenAgent"
            width="128"
            class="lg:ut-block"
          />
        </div>
      </div>
    </div>
    <h2 class="ut-text-3xl ut-text-center ut-font-bold ut-pb-3 md:ut-pb-8">
      Vendor Details
    </h2>
    <div class="ut-container-lg">
      <div class="ut-flex">
        <div
          class="
            ut-bg-green-600
            ut-rounded-full
            ut-h-32
            ut-w-32
            ut-justify-self-center
            ut-flex
            ut-mx-auto
            ut-items-center
            ut-justify-center
            ut-text-5xl
            ut-font-bold
          "
          style="color: white"
        >
          {{ firstName.substring(0, 1)
          }}{{
            (!lastName || lastName == "") ? firstName.slice(firstName.length - 1) : ""
          }}{{ (lastName && lastName != "") ? lastName.substring(0, 1) : "" }}
        </div>
        <div class="ut-p-4 ut-text-left ut-space-y-4 ut-flex-1">
          <p>
            <span class="ut-text-lg ut-font-semibold ut-block">{{
              caseDetails.leadname
            }}</span>
            <span class="ut-font-medium ut-block"
              >{{ caseDetails.leadstreet }}, {{ caseDetails.leadsuburb }}
              {{ caseDetails.leadstate }}</span
            >
          </p>
          <p class="ut-pt-2" style="border-top: 1px solid #888">
            <span class="phone">{{ caseDetails.leadphone }}</span>
            <span class="mail">{{ lead.email }}</span>
          </p>
        </div>
      </div>
    </div>
    <h2 class="ut-text-3xl ut-text-center ut-font-bold ut-pb-3 md:ut-pb-8">
      Case Details
    </h2>
    <div class="ut-container-lg">
      <div class="ut-flex form-group">
        <select
          class="ut-flex-1"
          @change="onSelectReason($event)"
          id="reason-for-closing-lead"
          v-model="selectedReasonId"
        >
          <option value="">Select reason...</option>
          <option
            v-for="reason in caseTypes"
            :key="reason.id"
            :value="reason.id"
          >
            {{ reason.type }}
          </option>
        </select>
      </div>
      <div class="ut-pt-8">
        <div v-if="showUpload" class="form-group">
          <div class="ut-text-center ut-font-bold ut-text-lg">
            Relevant Documents
          </div>
          <div class="upload">
            <evr-file-upload
              :ak="caseDetails.agentid"
              :lk="caseDetails.leadkey"
              :lid="caseDetails.leadid"
              :callback="loadAgentFiles"
            ></evr-file-upload>
            <div
              class="
                ut-overflow-y-auto ut-grid ut-grid-cols-1 ut-gap-4 ut-m-5
                md:ut-grid-cols-4
              "
            >
              <!-- existing files -->

              <!-- currently uploaded -->
              <div
                class="ut-break-all ut-text-center"
                :key="file.id"
                v-for="file in files.filter((f) => f.uploadstatustypeid != 2)"
              >
                <div class="ut-flex">
                  <div
                    class="ut-flex-auto ut-text-green-600 ut-cursor-pointer"
                    @click="selectFile(file)"
                  >
                    {{ file.name }}
                  </div>
                  <div class="ut-flex-auto ut-w-16">
                    <img
                      @click="deleteFile(file)"
                      class="
                        ut-mt-5
                        ut-object-none
                        ut-object-center
                        ut-cursor-pointer
                      "
                      src="@/assets/images/close.svg"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <textarea
          class="ut-flex"
          rows="5"
          placeholder="Notes"
          v-model="notes"
        />
      </div>
      <div class="form-group ut-mb-5 ut-text-right md:ut-text-center">
        <button
          type="button"
          @click="confirmUpdate"
          :disabled="!showUpload || updating"
          class="btn btn-green"
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import EvrFileUpload from "@/components/EvrFileUpload.vue";
import Axios from "axios";

export default {
  name: "case",
  components: { EvrFileUpload },
  props: {
    uk: String,
    ck: String,
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      selectedReasonId: null,
      showUpload: false,
      preUploadedFiles: [],
      notes: "",
      updating: false,
    };
  },
  created() {
    this.getCaseDetails();
  },
  computed: {
    ...mapGetters("userStore", [
      "isPremier",
      "isPrincipal",
      "isDeviceVerified",
    ]),
    ...mapState({
      user: (state) => state.userStore.user,
      lead: (state) => state.leadAgentMappingStore.lead,
      lam: (state) => state.leadAgentMappingStore.lam,
      files: (state) => state.leadAgentMappingStore.files,
      caseDetails: (state) => state.caseStore.caseDetails,
      caseTypes: (state) => state.caseStore.caseTypes,
    }),
  },
  methods: {
    ...mapActions("caseStore", [
      "loadCaseDetails",
      "updateCaseDetails",
      "getCaseTypes",
      "createNote",
    ]),
    ...mapActions("leadAgentMappingStore", [
      "loadLeadAgentMapping",
      "getAgentUploadedFiles",
      "deleteUploadedFile",
    ]),
    async confirmUpdate() {
      this.updating = true;
      let caseData = {
        caseid: this.caseDetails.id,
        parentid: this.caseDetails.parentid || null,
        leadid: this.caseDetails.leadid || null,
        agentid: this.caseDetails.agentid || null,
        ownerid: this.caseDetails.owneruserid,
        statustypeid: this.caseDetails.casestatustypeid,
        outcometypeid: this.caseDetails.caseoutcometypeid,
        prioritytypeid: this.caseDetails.caseprioritytypeid,
        casetypeid: this.selectedReasonId,
      };
      console.log(caseData);

      let caseDataStr = this.queryString(caseData);
      Axios.put(
        `${process.env.VUE_APP_API_URL}/CaseREST/update-case/${caseData.caseid}`,
        caseDataStr
      ).then((res1) => {
        if (res1.data.success) {
          let selectedCase = this.caseTypes.filter(
            (c) => c.id == this.selectedReasonId
          )[0];
          let agentEventData = {
            formname: "add-agent-event",
            agentid: this.caseDetails.agentid,
            userid: this.user.id,
            leadid: this.caseDetails.leadid,
            eventsource: "Agent Portal",
            eventtag: `Agent Declines Lead - ${selectedCase.type}`,
          };
          let agentEventDataStr = this.queryString(agentEventData);
          console.log("*** agentEventData", agentEventData);
          Axios.post(
            `${process.env.VUE_APP_API_URL}/AgentREST`,
            agentEventDataStr
          ).then((aeRes) => {
            console.log("******* agent event added: ", aeRes);

            if (this.notes && this.notes != "") {
              let noteData = {
                notetypeid: 11,
                leadid: this.caseDetails.leadid,
                agentid: this.caseDetails.agentid,
                userkey: this.uk,
                note: this.notes,
                caseid: this.caseDetails.id,
              };
              let noteDataStr = this.queryString(noteData);
              Axios.post(
                `${process.env.VUE_APP_API_URL}/NoteREST/create-note`,
                noteDataStr
              ).then((res2) => {
                if (res2.data.success) {
                  this.updating = false;
                  this.$modal.show("case-updated-modal");
                } else {
                  alert("Update failed!");
                }
              });
            } else {
              this.updating = false;
              this.$modal.show("case-updated-modal");
            }
          });
        } else {
          alert("Update failed!");
        }
      });
    },
    queryString(data) {
      let queryString = "";
      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          if (queryString.length > 0) {
            queryString += "&" + key + "=" + (data[key] || "");
          } else {
            queryString = key + "=" + (data[key] || "");
          }
        }
      }
      return queryString;
    },
    selectFile(file) {
      Axios.get(
        `${process.env.VUE_APP_API_URL}/FileStorageREST/get-download-file-url?filekey=${file.name}`
      ).then((response) => {
        window.open(response.data.postEndpoint, "_blank");
      });
    },
    onSelectReason(event) {
      this.selectedReasonId = event.target.value;
    },
    async loadAgentFiles() {
      if (this.lam.agentid && this.lam.leadid) {
        const payload = {
          leadId: this.lam.leadid,
          agentId: this.lam.agentid,
          type: 5,
        };
        await this.getAgentUploadedFiles(payload);
      }
    },
    async deleteFile(file) {
      await this.deleteUploadedFile({
        uploadkey: file.key,
        uploadstatustypeid: 2,
      });
      await this.loadAgentFiles();
    },
    getCaseDetails() {
      const payload = { caseId: this.ck };
      this.loadCaseDetails(payload).then(async () => {
        console.log(
          "****** case details",
          this.caseDetails,
          this.user,
          this.lead
        );

        const loadMappingParams = {
          leadKey: this.caseDetails.leadkey,
          agentKey: this.user.agentkey,
        };
        await this.loadLeadAgentMapping(loadMappingParams);
        this.firstName = this.lead.firstname;
        this.lastName = this.lead.lastname;

        this.selectedReasonId = this.caseDetails.casesubtypeid;
        const caseTypesParams = {
          subTypeId: this.caseDetails.casesubtypeid,
        };
        await this.getCaseTypes(caseTypesParams);
        await this.loadAgentFiles();

        this.showUpload = true;
      });
    },
  },
};
</script>

<style lang="scss">
@media (min-width: 1024px) {
  .case-outer {
      margin-left: -280px;
  }
}
.topbanner {
  background-color: #555;
}
</style>
<style lang="scss" scoped>
.case-outer {
  margin-left: -280px;
}

.phone,
.mail {
  background-repeat: no-repeat;
  display: block;
  padding: 0.5rem 0.75rem 0.5rem 1.8rem;
  background-position-y: 0.6rem;
}
.phone {
  background-image: url("../assets/styles/frontend-library/images/phone-grey.svg");
}
.mail {
  background-image: url("../assets/styles/frontend-library/images/mail-grey.svg");
}

.upload {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  width: 100%;
  border-radius: 0.25rem;
  border: 1px solid #ccc;
}

.btn-mini {
  padding: 0.15rem;
  margin-right: 10px;
}

.upload-container {
  margin-left: auto;
  margin-right: auto;
  display: block;
  width: 20rem;
  display: flex;
  margin-top: 20px;
  margin-bottom: 5px;
}
</style>
